/**
 * Gaveta — o menu no celular (< 1024 px): diálogo MODAL de verdade (padrão A, item 7).
 *
 *  - `role="dialog"` + `aria-modal="true"` + nome; o fundo fica `inert` (a casca cuida disso);
 *  - o foco entra no TÍTULO ao abrir, o Tab fica CONTIDO (Shift+Tab também), Esc e toque fora fecham, e o
 *    foco VOLTA ao botão "Abrir menu" (tudo isso é `useDialogoAcessivel` com `conterFoco`);
 *  - a rolagem do fundo é travada;
 *  - fechada, a gaveta NÃO EXISTE no DOM: nenhuma parada de Tab invisível. O código antigo só deslocava o
 *    painel com `translate-x`, e com ele fechado 13 das 14 primeiras tabulações caíam em itens fora da
 *    tela (NAV-03). Não voltar a esconder só por transformação.
 */
import { X } from "lucide-react";
import type { ReactNode } from "react";
import { useDialogoAcessivel } from "../../lib/dialogo-acessivel.js";

export function Gaveta({
  id,
  aberta,
  aoFechar,
  titulo = "Menu de navegação",
  marca,
  children,
  conta,
}: {
  id: string;
  aberta: boolean;
  aoFechar: () => void;
  titulo?: string;
  /** Bloco de marca (logo + nome do sistema). */
  marca: ReactNode;
  /** O menu (`NavLateral`). */
  children: ReactNode;
  /** Bloco "Conta" (tema, pessoa, papel, Sair) mostrado só abaixo de 640 px. */
  conta?: ReactNode;
}) {
  const ref = useDialogoAcessivel<HTMLDivElement>({ aberto: aberta, aoFechar, conterFoco: true, focoInicial: "[data-foco-inicial]" });
  if (!aberta) return null;
  const idTitulo = `${id}-titulo`;
  return (
    <div className="casca-gaveta-raiz">
      <div className="casca-gaveta-fundo" onClick={aoFechar} aria-hidden="true" />
      <div ref={ref} id={id} role="dialog" aria-modal="true" aria-labelledby={idTitulo} tabIndex={-1} className="casca-gaveta">
        <h2 id={idTitulo} tabIndex={-1} data-foco-inicial className="sr-only">{titulo}</h2>
        <div className="casca-gaveta-topo">
          {marca}
          <button type="button" className="casca-btn" aria-label="Fechar menu" onClick={aoFechar}>
            <X size={22} aria-hidden="true" />
          </button>
        </div>
        {children}
        {conta && <div className="casca-conta">{conta}</div>}
      </div>
    </div>
  );
}
